import React from 'react';
import './styles.css';
import MandelbrotPlayground from './components/MandelbrotPlayground';

function App() {
  return (
    <div className="App">
      <MandelbrotPlayground />
    </div>
  );
}

export default App;